import { BillingPlanDto, isShopifyBilledUser } from '@shared/core/billing'
import { CalendarsLimitType } from '@shared/core/billing/calendars-limit-type'
import type { GetProfileResponseDto } from '@shared/core/users'
import { getCalendarsLimitType } from 'src/modules/payment/utils/helpers'
import { CalendarDto } from 'src/types/calendar.dto'

export const LEGACY_FREE_PLAN_IDS: readonly number[] = [804349, 812490]

/** Accounts outside this cohort keep one upgrade link per locked calendar (D19). */
export function usesLockedCalendarsCard(profile: GetProfileResponseDto | undefined): boolean {
  if (!profile || profile.hide_billing_ui) return false
  if (isShopifyBilledUser(profile)) return false
  return !LEGACY_FREE_PLAN_IDS.includes(profile.subscription_plan_id)
}

export function hasNumericCalendarLimit(plan: BillingPlanDto | null): boolean {
  const limitType = getCalendarsLimitType(plan)
  return limitType === CalendarsLimitType.primary || limitType === CalendarsLimitType.default
}

export const sortCalendars = (calendars: CalendarDto[]): CalendarDto[] => {
  if (!calendars) return []

  return [...calendars].sort((a, b) => {
    if (a.primary && !b.primary) return -1
    if (!a.primary && b.primary) return 1
    return (a.title || a.calendar_id || '').localeCompare(b.title || b.calendar_id || '')
  })
}

export const isCalendarLimitReached = (
  plan: BillingPlanDto,
  calendar: CalendarDto,
  selectedCalendars: any[],
): boolean => {
  const calendarsLimitType = getCalendarsLimitType(plan)

  return (
    (calendarsLimitType === CalendarsLimitType.default && selectedCalendars.length >= plan.calendars_limit) ||
    (calendarsLimitType === CalendarsLimitType.primary && !calendar.primary)
  )
}

export const isCalendarLimitExceeded = (plan: BillingPlanDto, selectedCalendars: any[]): boolean => {
  const calendarsLimitType = getCalendarsLimitType(plan)

  return (
    (calendarsLimitType === CalendarsLimitType.primary && selectedCalendars.length > 1) ||
    (calendarsLimitType === CalendarsLimitType.default && selectedCalendars.length > plan.calendars_limit)
  )
}
